<template>
  <div>
    <form method="POST" class="dcf-form" novalidate>
      <fieldset>
        <legend>Profile</legend>

        <div class="dcf-grid dcf-grid-fifths@md dcf-col-gap-4">

          <div class="dcf-col">
            <fieldset>
              <legend>Type</legend>
              <div class="dcf-input-checkbox">
                <input id="bovine-type-d" v-model="profile.type" name="type[]" value="D" type="checkbox" /> <label for="bovine-type-d">Dairy</label>
              </div>
              <div class="dcf-input-checkbox">
                <input id="bovine-type-b" v-model="profile.type" name="type[]" value="B" type="checkbox" /> <label for="bovine-type-b">Beef</label>
              </div>
            </fieldset>
          </div>

          <div class="dcf-col">
            <fieldset>
              <legend>Weight</legend>
              <div class="dcf-input-checkbox">
                <input id="bovine-weight-l" v-model="profile.weight" name="weight[]" value="L" type="checkbox" /> <label for="bovine-weight-l">L</label>
              </div>
              <div class="dcf-input-checkbox">
                <input id="bovine-weight-h" v-model="profile.weight" name="weight[]" value="H" type="checkbox" /> <label for="bovine-weight-h">H</label>
              </div>
            </fieldset>
          </div>

          <div class="dcf-col">
            <fieldset>
              <legend>Muscling</legend>
              <div class="dcf-input-checkbox">
                <input id="bovine-muscling-hm" v-model="profile.muscling" name="muscling[]" value="H/M" type="checkbox" /> <label for="bovine-muscling-hm">H/M</label>
              </div>
              <div class="dcf-input-checkbox">
                <input id="bovine-muscling-l" v-model="profile.muscling" name="muscling[]" value="L" type="checkbox" /> <label for="bovine-muscling-l">L</label>
              </div>
            </fieldset>
          </div>
          <div class="dcf-col">
            <fieldset>
              <legend>Fat Thickness</legend>
              <div class="dcf-input-checkbox">
                <input id="bovine-fat-lt" v-model="profile.fat_thick" name="fat_thick[]" value="<.10" type="checkbox" /> <label for="bovine-fat-lt">&lt;.10</label>
              </div>            
              <div class="dcf-input-checkbox">
                <input id="bovine-fat-gt" v-model="profile.fat_thick" name="fat_thick[]" value=">.10" type="checkbox" /> <label for="bovine-fat-gt">&gt;.10</label>
              </div>
            </fieldset>
          </div>
          
          <div class="dcf-col">
            <fieldset>
              <legend>Maturity</legend>
              <div class="dcf-input-checkbox">
                <input id="bovine-maturity-cd" v-model="profile.maturity" name="maturity[]" value="C/D" type="checkbox" /> <label for="bovine-maturity-cd">C/D</label>
              </div>
              <div class="dcf-input-checkbox">
                <input id="bovine-maturity-e" v-model="profile.maturity" name="maturity[]" value="E" type="checkbox" /> <label for="bovine-maturity-e">E</label>
              </div>
            </fieldset>
          </div>
        </div>

      </fieldset>

      <div class="dcf-form-group">
        <label for="select_label">Processing Characteristics</label>
        <div class="dcf-input-group">
          <select id="select_label" v-model="selected_label">
            <option v-for="label in labels" :value="label" :disabled="values.indexOf(label) > -1">{{ label.label_name }}</option>
          </select>
          <button type="button" class="dcf-btn" v-on:click="addValue">Add Characteristic</button>
        </div>
      </div>

      <fieldset v-for="(value, i) in values">
        <legend>{{ value.label_name }}</legend>

        <input type="hidden" :name="'values[' + i + '][id]'" :value="value.id" />

        <div class="dcf-grid dcf-grid-halves@md dcf-col-gap-4">
          <div class="dcf-col">
            <div class="dcf-form-group">
              <label :for="'values[' + i + '][minValue]'">Minimum Value:</label>
              <input type="number" :id="'values[' + i + '][minValue]'"  :name="'values[' + i + '][minValue]'" v-model.number="value.minValue">
              <p class="dcf-form-help">Minimum Mean Value: {{ value.min }}</p>
            </div>
          </div>

          <div class="dcf-col">
            <div class="dcf-form-group">
              <label :for="'values[' + i + '][maxValue]'">Maximum Value:</label>
              <input type="number" :id="'values[' + i + '][maxValue]'" :name="'values[' + i + '][maxValue]'" v-model.number="value.maxValue">
              <p class="dcf-form-help">Maximum Mean Value: {{ value.max }}</p>
            </div>
          </div>
        </div>
        <button v-on:click="values.splice(i, 1)" class="dcf-btn dcf-btn-secondary">Remove</button>
      </fieldset>


      <button class="dcf-btn dcf-btn-primary" type="submit" :disabled="!validInput">Search</button>
    </form>
  </div>
</template>

<script>

export default {
  data: function(){
    return {
      labels: [],
      profile: {
        type: ['B', 'D'],
        weight: ['L', 'H'],
        muscling: ['H/M', 'L'],
        fat_thick: ['>.10', '<.10'],
        maturity: ['C/D', 'E']
      },
      values: [],
      selected_label: null
    }
  },
  computed: {
    validInput: function(){
      var output = (this.values.length > 0) ? true : false;
      for(var i = 0; i < this.values.length; i++){
        output = !(this.values[i].minValue && this.values[i].maxValue) ? false : output;
      }
      return output;
    }
  },
  methods: {
    addValue: function(){
      this.values.push(this.selected_label);
    }
  },
  created: function(){
    this.labels = window.labels;
  }
}

</script>
